null


// WEBPACK FOOTER //
// https://raw.githubusercontent.com/japgolly/scalajs-react/v1.7.0/core/src/main/scala/japgolly/scalajs/react/Callback.scala